<template>
  <DescriptionSection>
    <DescriptionItem
      v-if="service.additionalInfo"
      title="Dodatkowe informacje"
      :value="service.additionalInfo"
    ></DescriptionItem>
  </DescriptionSection>
</template>

<script>
import DescriptionSection from '@/component/Description/description-section';
import DescriptionItem from '@/component/Description/description-item';

export default {
  name: 'TrainCleaningDetails',
  components: {
    DescriptionSection,
    DescriptionItem,
  },
  props: {
    service: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
